import { useTranslation } from "react-i18next"
import { OopsLocalError } from "../OopsLocalError"
import { ApolloError } from "@apollo/client/errors"
import Oops from "../Oops/Oops"

interface TimelineErrorProps {
  error?: ApolloError
}

export const TimelineError = (props: TimelineErrorProps) => {
  const { error } = props
  const { t } = useTranslation("timeline")

  return error ? <OopsLocalError error={error} heading={t("error.fetchError")} /> : <Oops />
}
